import { Component } from '@angular/core';
import { KeycloakMigrationService } from "../../../services/keycloak-migration.service";
import { EventEmitterWithObservable } from "../../../../shared/EventEmitterWithValueReturned";

@Component({
    selector: 're-keycloak-user-import-list',
    templateUrl: './keycloak-user-import-list.component.html',
    styleUrls: ['./keycloak-user-import-list.component.scss'],
    standalone: false
})
export class KeycloakUserImportListComponent {

  constructor(private keycloakService: KeycloakMigrationService) { }

  load($event: EventEmitterWithObservable) {
    $event.ReturnValue = this.keycloakService.getTransactions();
  }
}
